import styled, { css } from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

const StickySortStyle = css`
    &.sorted-0 {
        background: ${({ theme }) => theme.Table.highlightPrimary};
    }

    &.sorted-1 {
        background: ${({ theme }) => theme.Table.highlightSecondary};
    }

    &.sorted-2 {
        background: ${({ theme }) => theme.Table.highlightTertiary};
    }
`;

export const StickyTable = css`
    .sticky {
        position: sticky;
        z-index: 1;
    }

    .rt-tr:nth-child(odd) .rt-td.sticky {
        ${StickySortStyle};
        background: ${({ theme }) => theme.Table.zebraStripe};
    }

    .rt-tr:nth-child(even) .rt-td.sticky,
    .rt-th.sticky {
        ${StickySortStyle};
        background: ${({ theme }) => theme.Surface.primary};
    }
`;

export const LeftShadowForStickyColumns = styled.div<{
    $scrollPosition: number;
    $shadowHeight: number;
    $toTop: number;
    $leftPosition: number;
    $leftPositionAboveMedium?: number;
    $leftPositionAboveLarge?: number;
    $leftPositionAboveExtraLarge?: number;
}>`
    background-color: rgba(0, 0, 0, 0);
    background-image: linear-gradient(to left, rgba(217, 217, 217, 0), rgba(217, 217, 217, 0.46));
    position: absolute;

    top: ${({ $toTop }) => `${$toTop}px`};
    left: ${({ $leftPosition }) => `${$leftPosition}px`};
    width: ${({ $scrollPosition }) => ($scrollPosition > 0 ? `${$scrollPosition}px` : 0)};
    height: ${({ $shadowHeight }) => `calc(${$shadowHeight}px - 10px)`};

    ${({ $leftPositionAboveMedium }) =>
        $leftPositionAboveMedium &&
        css`
            ${BaseStyle.Mixins.screenSizes.medium} {
                left: ${$leftPositionAboveMedium}px;
            }
        `}

    ${({ $leftPositionAboveLarge }) =>
        $leftPositionAboveLarge &&
        css`
            ${BaseStyle.Mixins.screenSizes.large} {
                left: ${$leftPositionAboveLarge}px;
            }
        `}


    ${({ $leftPositionAboveExtraLarge }) =>
        $leftPositionAboveExtraLarge &&
        css`
            ${BaseStyle.Mixins.screenSizes.extraLarge} {
                left: ${$leftPositionAboveExtraLarge}px;
            }
        `}
`;
